import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import refs from '../helpers/refs'

class CCategorySlider {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.numSlides = this.component.querySelectorAll('.glide__slide').length
    this.init()
  }

  init () {
    const slides = this.component.querySelectorAll('.glide__slide') ?? []

    this.glide = new Glide(this.$refs.slider, {
      type: 'slider',
      gap: 32,
      perView: this.numSlides > 3 ? 2.8 : 3,
      breakpoints: {
        512: {
          perView: 1.15,
          gap: 16
        },
        768: {
          perView: 1.5,
          gap: 16
        },
        1024: {
          perView: 1.9,
          gap: 32
        },
        1366: {
          perView: 2.3,
          gap: 32
        },
        1680: {
          perView: 2.7,
          gap: 32
        },
        1920: {
          perView: this.numSlides > 3 ? 2.9 : 3,
          gap: 32
        }
      }
    })

    this.glide.on('mount.after', () => {
      this.$refs.slider.classList.remove('opacity-0')
    })

    this.glide.on('run', () => {
      this.setControls(this.glide.index)
    })

    this.glide.mount({ Controls, Keyboard, Breakpoints, Swipe })

    // Control buttons
    this.$refs.controls.forEach((control) => {
      control.addEventListener('click', (e) => {
        const index = parseInt(control.closest('[data-index]').dataset.index)
        this.glide.go(`=${index}`)
        this.setControls(index)
      })
    })

    // Adding aria-hidden property to clones
    const cloneSelector = `.${this.glide.settings.classes.cloneSlide}`
    this.$refs.slider
      .querySelectorAll(cloneSelector)
      .forEach(el => el.setAttribute('aria-hidden', 'true'))

    // Clicking on the slides themselves
    slides.forEach((slide) => {
      slide.addEventListener('click', (e) => {
        // Don't trigger the slide click action when clicking an inner link
        if (e.target && e.target.nodeName !== 'SPAN') {
          // Instead of going to the slide, go to the shop page
          window.location.href =
            e.target.closest('.glide__slide').dataset.shopUrl

          /*
          let index = parseInt(e.target.closest('.glide__slide').dataset.index) - 1 // -1 to get the active slide in the center of the screen

          // Figure out if we're now clicking on a repeated slide (ie: jump back to 2 vs jump forward to 2 + numSlides)
          const lowerIndexDist = Math.abs(this.glide.index - index)
          const upperIndexDist = Math.abs(this.glide.index - (index + this.numSlides))
          index = lowerIndexDist < upperIndexDist ? index : index + this.numSlides

          // If clicking on a repeated slide - use go('>') hack to show repeating slides
          // If not, jump straight to the slide
          if (index >= this.numSlides) {
            this.glide.index = this.numSlides - 1
            this.glide.go('>')
          } else if (index < 0) {
            this.glide.go('<')
          } else {
            this.glide.go(`=${index}`)
            this.setControls(index)
          }
          */
        }
      })
    })

    // Button: Previous Category
    this.$refs.prevCategory.addEventListener('click', (event) => {
      event.preventDefault()

      this.glide.go('<')
    })

    // Button: Next Category
    this.$refs.nextCategory.addEventListener('click', (event) => {
      event.preventDefault()

      this.glide.go('>')
    })

    this.setControls(0)
  }

  // Set bottom controls state
  setControls (index) {
    this.$refs.controls.forEach((control) => {
      if (parseInt(control.getAttribute('data-index')) === index) {
        control.classList.add('c-category-slider__control-button--active')
      } else {
        control.classList.remove('c-category-slider__control-button--active')
      }
    })
  }
}

// Wait for images to load in
window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-category-slider]')
    .forEach(el => new CCategorySlider(el))
})
